<template>
  <div class="learning-situation">
    <a-row :gutter="8">
      <a-col :span="4">
        <a-input
          placeholder="搜索小组名称"
          allow-clear
          v-model="searchParams.groupName"
        />
      </a-col>
      <a-col :span="4">
        <a-input
          placeholder="学习机课程名称"
          allow-clear
          v-model="searchParams.courseName"
        />
      </a-col>
      <a-col :span="4">
        <a-button type="primary" @click="getGroupList" style="margin-right: 8px">
          搜索
        </a-button>
        <a-button @click="reset" class="ant-btn-secondary">
          重置
        </a-button>
      </a-col>
    </a-row>

    <a-spin :spinning="spinning">
      <div class="group-table-wrap">
        <a-collapse :active-key="activeKey" v-if="groupList.length > 0" @change="collapseChange" :bordered="false">
          <a-collapse-panel v-for="(item, groupIndex) in groupList" :key="item.groupId +''">
            <div slot="header" class="collapse-header">
              <a-tooltip placement="top">
                <template slot="title">
                  小组ID: {{ item.groupId }}
                </template>
                <span class="group-name">{{ item.groupName }}</span>
              </a-tooltip>

              <a-divider type="vertical" class="vertical" />
              <span class="course-name">{{ item.itvCourseName }}
                (共{{ item.studentNum }}人)</span>
            </div>
            <div class="student-table" :id="item.groupId+''">
              <a-row :gutter="8" class="student-table-filter">
                <template>
                  <span class="filter-selection" style="margin-right: 4px;">讲次定位</span>
                  <a-select
                    style="width: 190px"
                    :default-value="item.currentLessonNumId && item.currentLessonNumId"
                    @change="(v) => handleSelectChange(groupIndex, v, item)"
                    placeholder="请选择"
                  >
                    <a-select-option :value="lesson.id" v-for="lesson in item.lessonOption" :key="lesson.id">
                      第{{ lesson.num }}讲 {{ lesson.name || '--' }}
                    </a-select-option>
                  </a-select>
                </template>

                <template>
                  <a-checkbox-group
                    style="margin-left: 24px;"
                    v-model="item.checkedList"
                    @change="(v) => checkboxChange(v, groupIndex)"
                  >
                    <a-checkbox
                      :disabled="item.checkedList.length === 1 && item.checkedList.includes(type.id)"
                      v-for="type in item.typeOptions"
                      :key="type.id"
                      :value="type.id"
                    >
                      {{ type.name }}
                    </a-checkbox>
                    <a-button
                      class="ant-btn-secondary"
                      @click="refresh(groupIndex)"
                    >
                      刷新
                    </a-button>
                  </a-checkbox-group>
                </template>
                <a-spin :spinning="item.tableHeaderLoading" style="min-height: 200px;">
                  <a-table
                    :loading="item.studentTableLoading"
                    bordered
                    style="margin: 12px 0"
                    :scroll="item.scroll"
                    row-key="userId"
                    :columns="item.columns"
                    :data-source="item.studentList"
                    :pagination="false"
                  >
                    <template
                      v-for="propName in getSlotKeys(item)"
                      :slot="propName"
                      slot-scope="text, row"
                    >
                      <div :key="propName">
                        <!-- 答题正确率 -->
                        <div
                          :style="{color: text.answerCorrectRate > 0 && text.answerCorrectRate < 50 ? 'red' : ''}"
                          v-if="propName.includes('answerCorrectRate')"
                        >
                          {{ setCorrectRate(text) }}
                        </div>
                        <!-- 课本例练 -->
                        <a class="check-type" v-if="propName.includes('textbookPracticeVo')" @click="showModel(item, row, propName)">
                          {{ setBook(text) }}
                        </a>
                        <!-- 双色笔记 -->
                        <a class="check-type" v-if="propName.includes('twoColorNotes')" @click="showModel(item, row, propName)">
                          {{ setNotes(text) }}
                        </a>
                        <!-- 日积月累 -->
                        <a class="check-type" v-if="propName.includes('daysMonthsMultiply')" @click="showModel(item, row, propName)">
                          {{ setDaysMonths(text) }}
                        </a>
                        <!-- 融会贯通 -->
                        <a class="check-type" v-if="propName.includes('achieveMastery')" @click="showModel(item, row, propName)">
                          {{ setDaysMonths(text) }}
                        </a>
                      </div>
                    </template>

                    <!-- 备注title -->
                    <template slot="remarkTitle">
                      <p style="text-align: left;">
                        备注
                      </p>
                      <p style="font-size: 12px;color: #98A2B2">
                        <a-icon style="margin-right: 4px;" type="exclamation-circle" />最多可输入20个字
                      </p>
                    </template>

                    <!-- 备注列 -->
                    <template slot="remark" slot-scope="text, row">
                      <div class="remark-wrap">
                        <div class="text">
                          <p class="remark-text" v-if="row.remarkAdd && (row.remark && row.remark[0] && row.remark[0].remark)">
                            {{ row.remark[0].remark || '--' }}
                          </p>
                          <a-input
                            style="height: 21px;width: 100%;"
                            max-length="20"
                            v-else
                            v-model="row.currentRemark"
                            placeholder="请输入"
                          />
                        </div>
                        <div>
                          <!-- 添加 -->
                          <a-icon
                            class="action-icon-btn"
                            v-if="row.remarkAdd && row.remark && row.remark[0] && row.remark[0].remark"
                            @click="addRemark(groupIndex, row.userId)"
                            style="margin: 0 8px;"
                            type="plus"
                          />
                          <!-- 保存 -->
                          <a-icon
                            :style="{color: row.currentRemark ? '#3262FD' : '#98A2B2'}"
                            class="action-icon-btn"
                            type="check"
                            v-else
                            @click.stop="saveRemark(groupIndex, row.userId)"
                            style="margin: 0 8px;"
                          />
                          <!-- 取消 -->
                          <a-icon
                            class="action-icon-btn"
                            type="close"
                            v-if="!row.remarkAdd"
                            @click="cancelRemark(groupIndex, row.userId)"
                          />

                          <!-- 更多 -->
                          <a-tooltip placement="top" trigger="click" v-if="row.remarkAdd && row.remark && row.remark.length">
                            <template slot="title">
                              <ul class="remark-tooltip-ul" style="max-height: 200px;overflow-y:scroll">
                                <li
                                  style="height: 24px;display:flex;align-items: center;justify-content: space-between;"
                                  v-for="rmk in row.remark"
                                  :key="rmk.id"
                                >
                                  <div style="white-space: nowrap;">
                                    {{ rmk.remark }}
                                  </div>
                                  <a-icon
                                    @click="delRemark(groupIndex, row.userId, rmk.id)"
                                    style="padding-left: 10px;cursor: pointer;"
                                    type="close"
                                  />
                                </li>
                              </ul>
                            </template>
                            <a-icon class="action-icon-btn" type="ellipsis" />
                          </a-tooltip>
                        </div>
                      </div>
                    </template>
                  </a-table>
                </a-spin>
              </a-row>
            </div>
          </a-collapse-panel>
        </a-collapse>
        <a-empty style="margin-top:35vh" class="empty" description="暂无小组信息" v-if="groupList.length === 0 && !spinning" />
      </div>
    </a-spin>

    <div class="pagination" v-if="pagination.total > 0">
      <a-pagination
        v-model="pagination.current"
        :total="pagination.total"
        :page-size="pagination.pageSize"
        @change="handleChangePageNum"
      />
    </div>

    <!-- 小组弹窗 -->
    <CheckDeatil
      :check-params="checkParams"
      :visible.sync="modalVisible"
    />
  </div>
</template>

<script>
import learningSituationLogger from '@/utils/logger/learningSituation.js'
import lessonTag from './components/lessonTag.vue'
import CheckDeatil from './components/checkDeatil.vue'
import learningService from '@/service/learningSituation'
import { setCorrectRate, setBook, setNotes, setDaysMonths } from './learn.js'
import { throttle } from 'lodash'
const { createRmark, delRmark, queryRmark } = learningService
const typeOptions = [
  {
    id: 1,
    name: '答题正确率',
    key: 'answerCorrectRate'
  },
  {
    id: 2,
    name: '课本例练',
    key: 'textbookPracticeVo'
  },
  {
    id: 3,
    name: '双色笔记',
    key: 'twoColorNotes'
  },
  {
    id: 4,
    name: '日积月累',
    key: 'daysMonthsMultiply'
  },
  {
    id: 5,
    name: '融会贯通',
    key: 'achieveMastery'
  }
]

export default {
  name: 'LearningSituation',

  components: {
    CheckDeatil
  },

  data() {
    return {
      setCorrectRate,
      setBook,
      setNotes,
      setDaysMonths,
      modalVisible: false,
      spinning: false,
      activeKey: [],
      groupList: [], // 小组列表
      checkParams: {},
      searchParams: {
        groupName: undefined,
        courseName: undefined
      },
      showEmpty: false,
      pagination: {
        pageSize: 10,
        total: 0,
        current: 1
      }
    }
  },

  created() {
    learningSituationLogger.initPageLogger()
    this.getGroupList()
  },

  methods: {
    showModel(group, studentInfo, keyName) {
      const { classTypeId } = group
      const { userId, userName } = studentInfo
      const lessonId = keyName.split('_')[1]
      const activeKey = keyName.split('_')[2]
      const practiceName = typeOptions.find(k => k.id === Number(activeKey)).name
      this.checkParams = {
        userId,
        classTypeId,
        lessonId,
        activeKey,
        practiceName,
        userName
      }
      this.modalVisible = true
    },
    getSlotKeys(group) {
      if (!group.studentList.length) return []
      const arr = []
      const keys = Object.keys(group.studentList[0])
      keys.forEach(k => {
        if (k.includes('answerCorrectRate') || k.includes('textbookPracticeVo') || k.includes('twoColorNotes') || k.includes('daysMonthsMultiply') || k.includes('achieveMastery')) {
          arr.push(k)
        }
      })
      return arr
    },
    addRemark(groupIndex, userId) {
      this.groupList[groupIndex].studentList.forEach(stu => {
        stu.remarkAdd = !(stu.userId === userId)
      })
    },
    cancelRemark(groupIndex, id) {
      this.groupList[groupIndex].studentList.forEach(stu => {
        stu.currentRemark = ''
        const { userId } = stu
        if (userId === id) {
          stu.remarkAdd = true
        }
      })
    },
    saveRemark: throttle(async function(groupIndex, id) {
      this.groupList[groupIndex].studentList.forEach(stu => {
        const { userId, currentRemark } = stu
        if (userId === id) {
          if (!currentRemark) {
            this.$message.info('请输入备注')
            return
          }
          createRmark({ userId, remark: currentRemark }).then(res => {
            stu.currentRemark = ''
            queryRmark({ userIds: [userId] }).then(result => {
              stu.remark = result[userId]
              stu.remarkAdd = userId === id
            })
          })
        }
      })
    }, 1 * 1000, { trailing: false }),
    delRemark: throttle(async function(groupIndex, uid, remarkId) {
      this.groupList[groupIndex].studentList.forEach(stu => {
        const { userId } = stu
        if (userId === uid) {
          delRmark({ id: remarkId }).then(() => {
            queryRmark({ userIds: [userId] }).then(result => {
              stu.remark = result[userId]
            })
          })
        }
      })
    }, 1 * 1000, { trailing: false }),
    setTableScrollRight(groupIndex) {
      // 计算滚动条滚动距离
      const { groupId, checkedList, currentLessonNumId } = this.groupList[groupIndex]
      const checkedListLen = checkedList.length
      let lessonNum
      this.groupList[groupIndex].lessonOption.forEach((k, i) => {
        if (k.id === currentLessonNumId) {
          lessonNum = i
        }
      })
      this.$nextTick(() => {
        const id = groupId + ''
        const dom = document.getElementById(id)
        const tableRef = dom.getElementsByClassName('ant-table-body')[0]
        if (tableRef) {
          tableRef.scrollLeft = lessonNum * 150 * checkedListLen
        }
      })
    },
    handleSelectChange(groupIndex, v) {
      this.groupList[groupIndex].currentLessonNumId = v
      this.setTableScrollRight(groupIndex)
    },
    checkboxChange(v, i) {
      // 通过改变后的checklist 的值动态设置column
      const lessons = this.groupList[i].lessonOption
      const groupId = this.groupList[i].groupId
      this.setColumns({ groupId, lessons, groupIndex: i })
    },
    sorterFn(a, b, type, k) {
      if (type.key === 'answerCorrectRate') {
        // 答题正确率
        return a[`${type.key}_${k.id}_${type.id}`].answerCorrectRate - b[`${type.key}_${k.id}_${type.id}`].answerCorrectRate
      }
      if (type.key === 'textbookPracticeVo') {
        // 课本例练
        return a[`${type.key}_${k.id}_${type.id}`].phase - b[`${type.key}_${k.id}_${type.id}`].phase
      }
      if (type.key === 'twoColorNotes') {
        // 双色笔记
        return a[`${type.key}_${k.id}_${type.id}`].phase - b[`${type.key}_${k.id}_${type.id}`].phase
      }
      if (type.key === 'daysMonthsMultiply') {
        // 融汇贯通
        return a[`${type.key}_${k.id}_${type.id}`].score - b[`${type.key}_${k.id}_${type.id}`].score
      }
      if (type.key === 'achieveMastery') {
        // 日记月累
        return a[`${type.key}_${k.id}_${type.id}`].score - b[`${type.key}_${k.id}_${type.id}`].score
      }
    },
    // 复选框改变、打开折叠、点击刷新的时候，单独处理列隐藏/展示问题
    setColumns({ groupId, lessons, groupIndex }) {
      const columns = [
        {
          title: '学员姓名',
          dataIndex: 'userName',
          key: 'userName',
          fixed: 'left',
          width: 120,
          ellipsis: true
        },
        {
          title: '手机号',
          dataIndex: 'phoneNum',
          key: 'phoneNum',
          fixed: 'left',
          width: 120
        },
        {
          dataIndex: 'remark',
          key: 'remark',
          scopedSlots: { title: 'remarkTitle', customRender: 'remark' },
          fixed: 'left',
          width: 240
        }
      ]
      lessons.forEach(k => {
        const lessonHead = {
          title: <lessonTag info={k} />,
          align: 'left',
          children: []
        }
        if (groupIndex >= 0) {
          // 复选框改变、打开折叠、点击刷新的时候，单独处理列隐藏/展示问题
          const arr = this.groupList[groupIndex].checkedList.sort((a, b) => a - b)
          typeOptions.forEach(type => {
            if (arr.includes(type.id)) {
              lessonHead.children.push({
                title: type.name,
                width: 150,
                ellipsis: false,
                dataIndex: `${type.key}_${k.id}_${type.id}`,
                key: `${type.key}_${k.id}_${type.id}`,
                scopedSlots: { customRender: `${type.key}_${k.id}_${type.id}` },
                sorter: (a, b) => this.sorterFn(a, b, type, k),
                defaultSortOrder: 'descend',
                sortDirections: ['descend', 'ascend', false]
              })
            }
          })
        } else {
          typeOptions.forEach(type => {
            lessonHead.children.push({
              title: type.name,
              width: 150,
              ellipsis: false,
              dataIndex: `${type.key}_${k.id}_${type.id}`,
              key: `${type.key}_${k.id}_${type.id}`,
              scopedSlots: { customRender: `${type.key}_${k.id}_${type.id}` },
              sorter: this.sorterFn(a, b, type, k),
              defaultSortOrder: 'descend',
              sortDirections: ['descend', 'ascend', false]
            })
          })
        }
        columns.push(lessonHead)
      })
      this.groupList[groupIndex].columns = columns

      // 获取非固定列数量
      let columnNum = 0
      this.groupList[groupIndex].columns.forEach(k => {
        if (k.children) columnNum += k.children.length
      })
      // 非固定列宽度
      this.groupList[groupIndex].scroll.x = columnNum * 150
      try {
        // 列宽处理，防止列宽总和小于表格宽度时，出现空白列的问题
        this.$nextTick(() => {
          const dom = document.getElementById(+groupId)
          const tableRef = dom.getElementsByClassName('ant-table-body')[0] // 表格宽度
          if ((this.groupList[groupIndex].scroll.x + 480) > tableRef.offsetWidth) {
            // 有滚动条时宽度固定150
            this.groupList[groupIndex].columns.forEach(k => {
              if (k.children) {
                k.children.forEach(item => {
                  item.width = 150
                })
              }
            })
          } else {
            // 获取需要等分宽度的列数量
            if (columnNum) {
              // 等分固定列之外的宽度
              const width = parseInt((tableRef.offsetWidth - 480) / columnNum)
              this.groupList[groupIndex].columns.forEach(k => {
                if (k.children) {
                  k.children.forEach(item => {
                    item.width = width
                  })
                }
              })
            }
          }
        })
      } catch (err) {
        console.error('列宽适配出错', err)
      }
    },
    async getLessonsByClass({ classTypeId, groupId }) {
      let groupIndex
      try {
        // 讲次信息获取、初始化下拉框、默认选中第一讲
        const resultLessons = await this.$service.supervision.getLessonsByClassId({ classTypeId })
        // 限制展示50讲次
        const lessonArr = resultLessons.slice(0, 50)
        this.groupList.forEach((group, i) => {
          if (Number(group.groupId) === groupId) {
            groupIndex = i
            this.groupList[i].lessonOption = lessonArr.map(lesson => ({
              id: lesson.id,
              name: lesson.name,
              num: lesson.num,
              tag: lesson.tag
            }))
            this.groupList[i].currentLessonNumId = lessonArr[0].id
          }
        })
        // 创建表头
        this.setColumns({ groupId, lessons: lessonArr, groupIndex })
      } catch (err) {
        console.error('获取讲次出错')
      } finally {
        this.groupList[groupIndex].tableHeaderLoading = false
      }
    },
    async afterOpen(lastOpenGroupId) {
      let idx
      const { classTypeId, groupId } = this.groupList.find((item, i) => {
        idx = i
        return lastOpenGroupId - 0 === item.groupId
      })
      if (this.groupList[idx].columns.length > 0) {
        // 有数据时，展开不再请求
        return false
      }
      // // 获取讲次 【增加讲次loading】
      this.groupList[idx].tableHeaderLoading = true
      await this.getLessonsByClass({ classTypeId, groupId })
      this.groupList[idx].tableHeaderLoading = false
      // 获取学员列表数据并组装
      this.getStudentList({ xkhTeacherCourseId: lastOpenGroupId })
    },
    collapseChange(keys, index) {
      if (keys.length === 0) this.activeKey = []
      let lastOpenGroupId
      // 打开时
      if (keys.length > this.activeKey.length) lastOpenGroupId = keys[keys.length - 1] + ''
      // id类型转换
      this.activeKey = keys.map(k => String(k))
      if (!lastOpenGroupId) return
      // 解决折叠面板展开300毫秒卡顿问题，$nextTick对动画失效
      setTimeout(() => {
        this.afterOpen(lastOpenGroupId)
      }, 300)
    },
    async getStudentList({ xkhTeacherCourseId }) {
      let groupIndex
      this.groupList.forEach((k, i) => {
        if (Number(k.groupId) === Number(xkhTeacherCourseId)) {
          groupIndex = Number(k.groupId) === Number(xkhTeacherCourseId) && i
        }
      })
      this.groupList[groupIndex].studentTableLoading = true

      const { kanbanList, remarkList } = this.$service.learningSituation
      // 获取学员
      let kanbanResult
      try {
        kanbanResult = await kanbanList({ xkhTeacherCourseId })
      } catch (err) {
        this.groupList[groupIndex].studentTableLoading = false
        console.error('看板数据获取错误', err)
      }
      const { detailList } = kanbanResult
      const userIds = !detailList ? null : detailList.map(k => k.userId)
      if (!userIds) {
        this.groupList[groupIndex].studentTableLoading = false
        return false
      }
      // 获取备注
      let remarks
      try {
        remarks = await remarkList({ userIds })
      } catch (err) {
        console.error('备注接口获取错误', err)
      }
      const arr = []
      let idx = 0
      this.groupList.forEach((k, i) => {
        if (k.groupId - 0 === xkhTeacherCourseId - 0) {
          idx = i
          this.groupList[i].studentList = []
          detailList.forEach(detail => {
            const obj = {
              phoneNum: detail.phoneNum,
              userId: detail.userId,
              userName: detail.userName,
              remarkAdd: true,
              currentRemark: '',
              remark: []
            }
            // 添加备注字段
            if (JSON.stringify(remarks) !== '{}') {
              obj.remark = remarks[detail.userId] || []
            }
            detail.xkhLearnKanBanLessonOutBeanList.forEach(k => {
              obj[`answerCorrectRate_${k.lessonId}_1`] = k
              obj[`textbookPracticeVo_${k.lessonId}_2`] = k.textbookPractice
              obj[`twoColorNotes_${k.lessonId}_3`] = k.twoColorNotes
              obj[`daysMonthsMultiply_${k.lessonId}_4`] = k.daysMonthsMultiply
              obj[`achieveMastery_${k.lessonId}_5`] = k.achieveMastery
            })
            arr.push(obj)
          })
        }
      })
      this.groupList[idx].studentList = [...arr]
      this.groupList[groupIndex].studentTableLoading = false
    },
    // 组列表请求节流 1s
    getGroupList: throttle(async function() {
      this.groupList = []
      this.spinning = true
      const params = {
        groupName: this.searchParams.groupName,
        itvCourseName: this.searchParams.courseName,
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
        sourceType: 1,
        hideStatus: 0
      }
      const res = await this.$service.groupManage.getGroupList(params)
      if (!res.list || !res.list.length) {
        this.spinning = false
        this.showEmpty = true
        this.pagination = {
          ...this.pagination,
          total: res.itemTotal,
          current: res.pageNum
        }
        return false
      }
      this.showEmpty = false

      this.pagination = {
        ...this.pagination,
        total: res.itemTotal,
        current: res.pageNum
      }
      this.spinning = false
      // 组列表渲染
      res.list.forEach(group => {
        this.groupList.push({
          tableHeaderLoading: false,
          studentTableLoading: false,
          groupName: group.groupName,
          groupId: group.id,
          itvCourseName: group.itvCourseName,
          classTypeId: group.classTypeId,
          studentNum: group.studentNum,
          checkedList: [1, 2, 3, 4, 5],
          typeOptions,
          studentList: [],
          columns: [],
          scroll: { x: 1280, y: 400 }
        })
      })
      // 默认展开第一组
      this.activeKey = [res.list[0].id + '']
      const { classTypeId, id } = res.list[0]
      // 获取讲次
      await this.getLessonsByClass({ classTypeId, groupId: id })
      // 获取学员列表数据并组装
      this.getStudentList({ xkhTeacherCourseId: this.groupList[0].groupId })
    }, 1 * 1000, { trailing: false }),
    reset() {
      Object.keys(this.searchParams).forEach(k => {
        this.searchParams[k] = undefined
      })
    },
    async refresh(idx) {
      const { classTypeId, groupId } = this.groupList[idx]
      // 获取讲次
      await this.getLessonsByClass({ classTypeId, groupId })
      // 获取学员列表数据并组装
      this.getStudentList({ xkhTeacherCourseId: groupId })
    },
    handleChangePageNum(current, pageSize) {
      this.pagination.current = current
      this.pagination.pageSize = pageSize
      this.getGroupList()
    }
  }
}
</script>
<style scoped lang="less">
@import '~@/static/css/base.less';
//解决固定列底部预留的空隙
:deep(.ant-table-fixed-left) {
  .ant-table-body-outer {
    margin-bottom: -6px !important;
  }
}
:deep(.ant-table-thead > tr > th) {
  white-space:nowrap;
}
:deep(.ant-table-body-inner) {
  &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
      background-color: transparent;
  }
  &::-webkit-scrollbar-thumb{
      width: 6px;
      height: 6px;
      opacity: 0.8;
      border-radius: 3px;
      background: transparent;
  }
  &::-webkit-scrollbar-track {
      background: transparent;
  }
}

.remark-tooltip-ul, .group-table-wrap {
  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb{
    width: 6px;
    height: 6px;
    opacity: 0.8;
    border-radius: 3px;
    background: #C7C7C7;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-button {
    background: transparent;
  }
  &::-webkit-scrollbar-corner {
    background: transparent;
  }
}
.empty-group {
  height: 100%;
  padding: 24px;
  overflow: hidden;
  background: #fff;
}
.learning-situation {
  height: 100%;
  padding: 24px;
  overflow: hidden;
  background: #fff;
  :deep(.ant-table-wrapper .ant-table .ant-table-thead > tr > th) {
    vertical-align: middle !important;
  }
  .group-table-wrap {
    height: calc(100vh - 52px - 46px - 148px);
    overflow-y: scroll;
    margin-top: 24px;
    .collapse-header {
      .group-name {
        font-size: 16px;
      }
      .vertical {
        width: 2px;
      }
      .course-name {
        font-size: 16px;
      }
    }
    .remark-wrap {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: left;
      .action-icon-btn {
        cursor: pointer;
        font-size: 16px;
        font-weight: 800;
        color: #3262FD;
      }

      .text {
        width: 150px;
        .remark-text {
          white-space: nowrap;
          overflow:hidden;
          text-overflow:ellipsis;
        }
      }
    }
    .ant-collapse {
      background: #fff;
    }
    :deep(.ant-collapse-item) {
      margin-bottom: 12px;
      background: #fafafa;
      border-bottom: none;
    }
    :deep(.ant-collapse-content-box) {
      background: #fff;
    }
  }
  .student-table-filter {
    padding-top: 12px;
  }
  .pagination {
    text-align: right;
    position:absolute;
    bottom: 24px;
    right: 48px;
  }
  .check-type {
    cursor: pointer;
  }
}
</style>
